/**
 * mascots — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const mascotsPack: ToilePack = {
    slug: 'mascots',
    category: 'mascots',
    name: 'Mascots',
    tagline: tagline('mascots', 'characters', 'styles'),
    chips: chips('characters', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'wolf', label: 'Esports wolf', subject: 'a snarling wolf head, ears back, a scar across the muzzle'},
        {key: 'bear', label: 'Bakery bear', subject: 'a chef bear with a tray of buns, a toque and a striped apron'},
        {key: 'bull', label: 'Gym bull', subject: 'a bull in a gym vest, arms crossed, thick horns and a nose ring'},
    ],
    styles: [
        {key: 'esports', label: 'Esports badge', style: 'aggressive angular shapes, heavy black keylines', palette: 'two colors plus white, beveled highlights', framing: 'centered, strong silhouette'},
        {key: 'rounded', label: 'Friendly rounded', style: 'soft thick outlines, simple rounded forms', palette: 'warm cheerful flat colors', framing: 'centered, strong silhouette'},
        {key: 'college', label: 'Retro college', style: 'a vintage varsity mascot, halftone texture', palette: 'a two-ink palette, print misregistration', framing: 'centered, strong silhouette'},
    ],
    directions: ['a hawk instead', 'in red and black', 'friendlier, less aggressive'],
}
